import React from "react"
import { Form, Radio } from "semantic-ui-react"

const RadioYesNo = ({ label, value, name, disabled, onChange }) => {
  return (
    <Form.Group inline>
      <Form.Field>
        <label>{label}</label>
      </Form.Field>
      <Form.Field inline>
        <Radio
          label="ΝΑΙ"
          checked={value === true}
          name={name}
          onChange={() => onChange(name, true)}
          disabled={disabled}
        />
        <Radio
          label="ΟΧΙ"
          checked={value === false}
          name={name}
          onChange={() => onChange(name, false)}
          disabled={disabled}
        />
      </Form.Field>
    </Form.Group>
  )
}

export default RadioYesNo
